module.exports = __webpack_public_path__ + "static/media/5.6f4d4f6d.png";